import { useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import { getCookieIds } from '@src/shared/helpers/cookie';

const hasCookie = (name: string) => {
    if (typeof document === 'undefined') return false;
    return document.cookie
        .split('; ')
        .some((cookie) => cookie.startsWith(`${name}=`));
};

const COOKIE_NAME = 'unsecuredApplication';
const EXPIRED_ROUTE = '/expired';

export const useSessionExpiryGuard = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const checkSession = () => {
            if (location.pathname === EXPIRED_ROUTE) return;
            const { sessionId } = getCookieIds();
            if (!hasCookie(COOKIE_NAME) || !sessionId) {
                navigate(EXPIRED_ROUTE, { replace: true });
            }
        };

        checkSession();

        const handleVisibilityChange = () => {
            if (!document.hidden) {
                checkSession();
            }
        };

        window.addEventListener('focus', checkSession);
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            window.removeEventListener('focus', checkSession);
            document.removeEventListener(
                'visibilitychange',
                handleVisibilityChange,
            );
        };
    }, [location.pathname, navigate]);
};
